import React from "react";
import ItemPlayList from "../../components/Home/ItemPlayList";

const CategoryList = () => {
  return (
    <div className="list__playlist__selection">
      <div className="item__playlist__selection">
        <a href="#">
          <div className="img__playlist__selection">
            <img
              src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/0/6/8/3/0683cf03b2c1f2e169a9439aea0b3d62.jpg"
              alt=""
            />

            <div className="option__playlist__selection">
              <div className="option__selection library__add__selection">
                <i className="fa-regular fa-heart"></i>
              </div>
              <div className="option__selection item__play__selection">
                {/* <i className="fa-solid fa-play"></i> */}
                <span className="gif__play">
                  <img
                    src="https://zmp3-static.zmdcdn.me/skins/zmp3-v6.1/images/icons/icon-playing.gif"
                    alt=""
                  />
                </span>
              </div>
              <div className="option__selection item__option__selection">
                <div className="option__icon__selection">● ● ●</div>
              </div>
            </div>
          </div>
        </a>
        <div className="title__playlist__selection">
          <a href="#" className="title__one__line">
            Cả Một Trời Thương Nhớ (Live in HOA Concert)
          </a>
          <div className="name__singer__all">
            <a href="#" className="name__singer">
              Noo Phước Thịnh
            </a>
          </div>
        </div>
      </div>
      <div className="item__playlist__selection">
        <a href="#">
          <div className="img__playlist__selection">
            <img
              src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/e/d/2/5/ed251cf560be4747e7737b535c357f07.jpg"
              alt=""
            />

            <div className="option__playlist__selection">
              <div className="option__selection library__add__selection">
                <i className="fa-regular fa-heart"></i>
              </div>
              <div className="option__selection item__play__selection">
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="option__selection item__option__selection">
                <div className="option__icon__selection">● ● ●</div>
              </div>
            </div>
          </div>
        </a>
        <div className="title__playlist__selection">
          <a href="#" className="title__one__line">
            #zingchart
          </a>
          <div className="name__singer__all">
            <a href="#" className="name__singer">
              Noo Phước Thịnh
            </a>
          </div>
        </div>
      </div>
      <div className="item__playlist__selection">
        <a href="#">
          <div className="img__playlist__selection">
            <img
              src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/0/7/6/3/076388b9c3ecd0aa14af0b829352e426.jpg"
              alt=""
            />

            <div className="option__playlist__selection">
              <div className="option__selection library__add__selection">
                <i className="fa-regular fa-heart"></i>
              </div>
              <div className="option__selection item__play__selection">
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="option__selection item__option__selection">
                <div className="option__icon__selection">● ● ●</div>
              </div>
            </div>
          </div>
        </a>
        <div className="title__playlist__selection">
          <a href="#" className="title__one__line">
            ERIK's Heartbreak Story
          </a>
          <div className="name__singer__all">
            <a href="#" className="name__singer">
              Noo Phước Thịnh
            </a>
          </div>
        </div>
      </div>
      <div className="item__playlist__selection">
        <a href="#">
          <div className="img__playlist__selection">
            <img
              src="https://photo-playlist-zmp3.zmdcdn.me/s1/mixtape?src=HavwqN7EYmrDGr6VBegSG044GDzhm8f0L0H1tpwBYGfGL4A2RTpT1GG5HDTisOzM0m0NqclVZ50111RPTeN83Wr2HD8znu4z5aL8vJkCt7S120IYAioVFKO81Q8jp9udG1K6eIlCc7H0H07rU9RE9a151VHzo9aYHnTJgtlEqt5IGb_jATsK9GGK0BSSaSOd2G-h8px4IL373wiZ8yH1_29z&cv=1&size=thumb/240_240"
              alt=""
            />

            <div className="option__playlist__selection">
              <div className="option__selection library__add__selection">
                <i className="fa-regular fa-heart"></i>
              </div>
              <div className="option__selection item__play__selection">
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="option__selection item__option__selection">
                <div className="option__icon__selection">● ● ●</div>
              </div>
            </div>
          </div>
        </a>
        <div className="title__playlist__selection">
          <a href="#" className="title__one__line">
            Mixtape Anh Luôn Là Lý Do
          </a>
          <div className="name__singer__all">
            <a href="#" className="name__singer">
              Noo Phước Thịnh
            </a>
          </div>
        </div>
      </div>
      <div className="item__playlist__selection">
        <a href="#">
          <div className="img__playlist__selection">
            <img
              src="https://photo-resize-zmp3.zmdcdn.me/w320_r1x1_webp/cover/c/f/7/6/cf76de6283cfa98ec85a301addb676e5.jpg"
              alt=""
            />

            <div className="option__playlist__selection">
              <div className="option__selection library__add__selection">
                <i className="fa-regular fa-heart"></i>
              </div>
              <div className="option__selection item__play__selection">
                <i className="fa-solid fa-play"></i>
              </div>
              <div className="option__selection item__option__selection">
                <div className="option__icon__selection">● ● ●</div>
              </div>
            </div>
          </div>
        </a>
        <div className="title__playlist__selection">
          <a href="#" className="title__one__line">
            Top 100 bài hát nhạc trẻ hay nhất
          </a>
          <div className="name__singer__all">
            <a href="#" className="name__singer">
              Noo Phước Thịnh
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
